module.exports = window.wp.widgets;